const base_url = "http://www.zonyou.cn";
// const base_url = 'http://192.168.10.16'

export default {
  base_url,
};
